import Footer from "@/components/Footer";
import { Mensaje, MensajeSiNo } from "@/components/mensajes2";
import { Dimmer } from "@/components/spinner";
import useTableService from "@/components/useTableServerSide";
import { SearchInput } from "@/ui/inputs/Input";
import { formatMoneda } from "@/util/varios";
import axios from "axios";
import moment from "moment";
import { useState, useEffect, useRef, useCallback } from "react";
import Modal from "react-bootstrap/Modal";

const headCells = [
  {
    id: "0",
    label: "CUENTA BANCARIA",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "1",
    label: "DOCUMENTO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "2",
    label: "TP",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "4",
    label: "MONTO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "5",
    label: "FACTURA",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "6",
    label: "RITM",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "7",
    label: "CONTRIBUYENTE",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "8",
    label: "PERIODO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "9",
    label: "FECHA PAGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "10",
    label: "FECHA RECHAZO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "11",
    label: "MOTIVO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "12",
    label: "OPCIONES",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
];

export default function ModalPagosRechazados({ show, hide, ...props }) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const searchTimeoutRef = useRef(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [records, setRecords] = useState([]);
  const [idPago, setIdPago] = useState();
  const [loading, setLoading] = useState(false);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });

  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),

    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({
        ...prev,
        rowsPerPage: newLimit,
        page: 0,
      })),

    onSortChange: (orderBy, orderDir) =>
      setTableState((prev) => ({
        ...prev,
        orderBy,
        orderDir,
        page: 0,
      })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

    if (value.length === 0) {
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    }

    if (value.length < 3) return;

    searchTimeoutRef.current = setTimeout(
      () =>
        setTableState((prev) => ({
          ...prev,
          search: value,
          page: 0,
        })),
      500,
    );
  };

  const blanquear = useCallback(() => {
    setTotalRecords(0);
    setSearchInput("");
    setRecords([]);
    setIdPago("");
    setLoading(false);

    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setTableState({
      page: 0,
      rowsPerPage: 10,
      search: "",
    });
  }, []);

  const cerrar = () => {
    if (hide) hide();
  };

  const seleccionarPago = ({ id }) => {
    setIdPago(id);

    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Esta seguro de activar este pago?",
      icono: "confirmacion",
    });
  };

  const activarPago = async () => {
    setLoading(true);

    const endpoint = `${op.conexion}/api/industria/activar-pagos-rechazados`;

    axios
      .post(
        endpoint,
        {
          idPago: idPago,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.status === 200 && res.data) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Pago Activado Correctamente",
            icono: "exito",
          });
        }
      })
      .catch(() => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Activar el Pago",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Limpiar cuando la modal se cierra
  useEffect(() => {
    if (!show) {
      blanquear();
    }
  }, [show, blanquear]);

  // Consultar solo cuando la modal está abierta
  useEffect(() => {
    if (!show) return;

    const controller = new AbortController();

    const fetchRegistros = async () => {
      setLoading(true);

      try {
        const params = {
          page: tableState.page,
          limit: tableState.rowsPerPage,
          orderBy: tableState.orderBy,
          orderDir: tableState.orderDir,
          search: tableState.search,
          condicion:
            "estatus = 2 and EXTRACT(YEAR from fecha) = EXTRACT(YEAR FROM CURRENT_DATE)",
        };

        const endpoint = `${op.conexion}/api/industria/buscar-pagos-rechazados`;

        const response = await axios.get(endpoint, {
          params,
          signal: controller.signal,
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      } catch (error) {
        if (axios.isCancel(error)) return;

        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchRegistros();

    return () => {
      controller.abort();
    };
  }, [show, tableState]);

  return (
    <Modal
      {...props}
      show={show}
      onHide={cerrar}
      size="xl"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold text-light m-0 text-uppercase">
          Consultar PAGOS WEB RECHAZADOS
        </h3>

        <button className="btn btn-sm bg-light" onClick={() => cerrar()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>

      <Modal.Body className="d-flex justify-content-between row">
        <div className="col-4 mx-3 my-2 p-0">
          <SearchInput
            className="search-input pe-4"
            value={searchInput}
            onChange={handleSearch}
          />
        </div>

        <div className="col-md-12 row mx-auto">
          <section className="col-12 m-0 p-0">
            <TblContainer>
              <TblHead />

              <tbody>
                {records &&
                  records.map((item, index) => (
                    <tr key={index} style={{ padding: "0" }}>
                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "125px",
                        }}
                      >
                        {item.cta}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.numerodocumento}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.tipopago}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "right",
                          width: "auto",
                        }}
                      >
                        {formatMoneda(
                          item.monto.toString().replace(".", ","),
                          ",",
                          ".",
                          2,
                        )}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.factura}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "10px",
                        }}
                      >
                        {item.ritm}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.contribuyente}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "10px",
                        }}
                      >
                        {item.periodo}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "100px",
                        }}
                      >
                        {moment(item.fecha).format("DD/MM/YYYY")}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "120px",
                        }}
                      >
                        {item.fecharechazo
                          ? moment(item.fecharechazo).format("DD/MM/YYYY")
                          : "S/N"}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.motivorechazo}
                      </td>

                      <td
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        <button
                          onClick={() =>
                            seleccionarPago({
                              id: item.idmovimientospago,
                            })
                          }
                          className="btn btn-sm btn-info rounded-pill"
                        >
                          <i className="fas fa-share-square"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>

            <TblPagination />
          </section>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          onClick={() => cerrar()}
          type="button"
          style={{ margin: "2px" }}
          className="fw-bold btn btn-danger btn-sm rounded-pill"
        >
          <i className="fa fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

          if (mensaje.titulo === "Exito.") {
            cerrar();
          }
        }}
      />

      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={() => {
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
          activarPago();
        }}
      />

      <Dimmer active={loading} inverted />
    </Modal>
  );
}
